import { render } from "./BinaryPage.vue?vue&type=template&id=d031a6de"
import script from "./BinaryPage.vue?vue&type=script&lang=js"
export * from "./BinaryPage.vue?vue&type=script&lang=js"

import "./BinaryPage.vue?vue&type=style&index=0&id=d031a6de&lang=scss"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__